module.exports = __webpack_public_path__ + "18d011633b567f8ca9acf8b2357774ed.png";